import React, { useState } from 'react';
import Icon from 'components/AppIcon';

const SecuritySettings = () => {
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [twoFactorEnabled, setTwoFactorEnabled] = useState(true);
  const [showQRCode, setShowQRCode] = useState(false);
  const [backupCodes] = useState([
    'A1B2C3D4', 'E5F6G7H8', 'I9J0K1L2', 'M3N4O5P6',
    'Q7R8S9T0', 'U1V2W3X4', 'Y5Z6A7B8', 'C9D0E1F2'
  ]);

  const activeSessions = [
    {
      id: 1,
      device: 'MacBook Pro',
      browser: 'Chrome 118.0',
      location: 'New York, NY',
      ipAddress: '192.168.1.100',
      lastActive: '2024-01-15T10:30:00Z',
      isCurrent: true
    },
    {
      id: 2,
      device: 'iPhone 15 Pro',
      browser: 'Safari Mobile',
      location: 'New York, NY',
      ipAddress: '192.168.1.101',
      lastActive: '2024-01-15T09:15:00Z',
      isCurrent: false
    },
    {
      id: 3,
      device: 'Windows PC',
      browser: 'Firefox 119.0',
      location: 'Boston, MA',
      ipAddress: '10.0.0.50',
      lastActive: '2024-01-14T16:45:00Z',
      isCurrent: false
    }
  ];

  const loginHistory = [
    {
      id: 1,
      timestamp: '2024-01-15T10:30:00Z',
      location: 'New York, NY',
      ipAddress: '192.168.1.100',
      device: 'MacBook Pro',
      status: 'success'
    },
    {
      id: 2,
      timestamp: '2024-01-15T09:15:00Z',
      location: 'New York, NY',
      ipAddress: '192.168.1.101',
      device: 'iPhone 15 Pro',
      status: 'success'
    },
    {
      id: 3,
      timestamp: '2024-01-14T16:45:00Z',
      location: 'Boston, MA',
      ipAddress: '10.0.0.50',
      device: 'Windows PC',
      status: 'success'
    },
    {
      id: 4,
      timestamp: '2024-01-14T14:20:00Z',
      location: 'Unknown',
      ipAddress: '203.0.113.1',
      device: 'Unknown Device',
      status: 'failed'
    }
  ];

  const handlePasswordChange = (field, value) => {
    setPasswordData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    // Handle password change logic
    console.log('Password change submitted');
  };

  const handleTerminateSession = (sessionId) => {
    console.log('Terminating session:', sessionId);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString();
  };

  return (
    <div className="p-6">
      {/* Header */}
      <div className="mb-6">
        <h2 className="text-xl font-heading-semibold text-text-primary mb-1">Security Settings</h2>
        <p className="text-sm text-text-secondary">Manage your account security and authentication methods</p>
      </div>

      {/* Password Change Section */}
      <div className="mb-8 p-6 border border-border rounded-trading">
        <h3 className="text-lg font-heading-semibold text-text-primary mb-4">Change Password</h3>
        
        <form onSubmit={handlePasswordSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-body-medium text-text-primary mb-2">
              Current Password *
            </label>
            <div className="relative">
              <input
                type={showCurrentPassword ? 'text' : 'password'}
                value={passwordData.currentPassword}
                onChange={(e) => handlePasswordChange('currentPassword', e.target.value)}
                className="w-full px-3 py-2 pr-10 border border-border rounded-trading focus:outline-none focus:ring-2 focus:ring-primary-100 focus:border-primary"
                placeholder="Enter current password"
              />
              <button
                type="button"
                onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-text-secondary hover:text-text-primary"
              >
                <Icon name={showCurrentPassword ? 'EyeOff' : 'Eye'} size={16} />
              </button>
            </div>
          </div>
          
          <div>
            <label className="block text-sm font-body-medium text-text-primary mb-2">
              New Password *
            </label>
            <div className="relative">
              <input
                type={showNewPassword ? 'text' : 'password'}
                value={passwordData.newPassword}
                onChange={(e) => handlePasswordChange('newPassword', e.target.value)}
                className="w-full px-3 py-2 pr-10 border border-border rounded-trading focus:outline-none focus:ring-2 focus:ring-primary-100 focus:border-primary"
                placeholder="Enter new password"
              />
              <button
                type="button"
                onClick={() => setShowNewPassword(!showNewPassword)}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-text-secondary hover:text-text-primary"
              >
                <Icon name={showNewPassword ? 'EyeOff' : 'Eye'} size={16} />
              </button>
            </div>
          </div>
          
          <div>
            <label className="block text-sm font-body-medium text-text-primary mb-2">
              Confirm New Password *
            </label>
            <div className="relative">
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                value={passwordData.confirmPassword}
                onChange={(e) => handlePasswordChange('confirmPassword', e.target.value)}
                className="w-full px-3 py-2 pr-10 border border-border rounded-trading focus:outline-none focus:ring-2 focus:ring-primary-100 focus:border-primary"
                placeholder="Confirm new password"
              />
              <button
                type="button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-text-secondary hover:text-text-primary"
              >
                <Icon name={showConfirmPassword ? 'EyeOff' : 'Eye'} size={16} />
              </button>
            </div>
          </div>
          
          <div className="pt-2">
            <button
              type="submit"
              className="px-6 py-2 bg-primary text-white rounded-trading hover:bg-primary-600 transition-colors duration-trading-fast"
            >
              Update Password
            </button>
          </div>
        </form>
      </div>

      {/* Two-Factor Authentication */}
      <div className="mb-8 p-6 border border-border rounded-trading">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="text-lg font-heading-semibold text-text-primary mb-1">Two-Factor Authentication</h3>
            <p className="text-sm text-text-secondary">Add an extra layer of security to your account</p>
          </div>
          
          <div className="flex items-center space-x-3">
            <span className={`text-sm font-body-medium ${twoFactorEnabled ? 'text-success' : 'text-text-secondary'}`}>
              {twoFactorEnabled ? 'Enabled' : 'Disabled'}
            </span>
            <button
              onClick={() => setTwoFactorEnabled(!twoFactorEnabled)}
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-trading-fast ${
                twoFactorEnabled ? 'bg-primary' : 'bg-secondary-300'
              }`}
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-trading-fast ${
                  twoFactorEnabled ? 'translate-x-6' : 'translate-x-1'
                }`}
              />
            </button>
          </div>
        </div>
        
        {twoFactorEnabled && (
          <div className="space-y-4">
            <div className="flex items-center space-x-4">
              <button
                onClick={() => setShowQRCode(!showQRCode)}
                className="flex items-center space-x-2 px-4 py-2 border border-border rounded-trading hover:bg-secondary-50 transition-colors duration-trading-fast"
              >
                <Icon name="QrCode" size={16} />
                <span className="font-body-medium text-sm">Show QR Code</span>
              </button>
              
              <button className="flex items-center space-x-2 px-4 py-2 border border-border rounded-trading hover:bg-secondary-50 transition-colors duration-trading-fast">
                <Icon name="Download" size={16} />
                <span className="font-body-medium text-sm">Download Backup Codes</span>
              </button>
            </div>
            
            {showQRCode && (
              <div className="p-4 bg-secondary-50 rounded-trading">
                <div className="flex items-center space-x-4">
                  <div className="w-32 h-32 bg-white border border-border rounded-trading flex items-center justify-center">
                    <Icon name="QrCode" size={64} className="text-text-secondary" />
                  </div>
                  <div>
                    <h4 className="font-body-medium text-text-primary mb-2">Scan with your authenticator app</h4>
                    <p className="text-sm text-text-secondary mb-3">
                      Use Google Authenticator, Authy, or any compatible TOTP app to scan this QR code.
                    </p>
                    <p className="text-xs font-data text-text-secondary bg-white px-2 py-1 rounded border">
                      Manual entry: JBSWY3DPEHPK3PXP
                    </p>
                  </div>
                </div>
              </div>
            )}
            
            <div>
              <h4 className="font-body-medium text-text-primary mb-2">Backup Codes</h4>
              <p className="text-sm text-text-secondary mb-3">
                Save these backup codes in a secure location. Each code can only be used once.
              </p>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                {backupCodes.map((code, index) => (
                  <div key={index} className="px-3 py-2 bg-secondary-50 rounded font-data text-sm text-center">
                    {code}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Active Sessions */}
      <div className="mb-8 p-6 border border-border rounded-trading">
        <h3 className="text-lg font-heading-semibold text-text-primary mb-4">Active Sessions</h3>
        
        <div className="space-y-4">
          {activeSessions.map((session) => (
            <div key={session.id} className="flex items-center justify-between p-4 border border-border rounded-trading">
              <div className="flex items-center space-x-4">
                <div className="w-10 h-10 bg-secondary-100 rounded-full flex items-center justify-center">
                  <Icon name="Monitor" size={20} className="text-text-secondary" />
                </div>
                <div>
                  <div className="flex items-center space-x-2">
                    <h4 className="font-body-medium text-text-primary">{session.device}</h4>
                    {session.isCurrent && (
                      <span className="px-2 py-1 bg-success-100 text-success text-xs rounded-trading">
                        Current
                      </span>
                    )}
                  </div>
                  <p className="text-sm text-text-secondary">{session.browser}</p>
                  <p className="text-sm text-text-secondary">{session.location} • {session.ipAddress}</p>
                  <p className="text-xs text-text-secondary">Last active: {formatDate(session.lastActive)}</p>
                </div>
              </div>
              
              {!session.isCurrent && (
                <button
                  onClick={() => handleTerminateSession(session.id)}
                  className="px-3 py-1 text-sm text-error hover:bg-error-50 rounded-trading transition-colors duration-trading-fast"
                >
                  Terminate
                </button>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Login History */}
      <div className="p-6 border border-border rounded-trading">
        <h3 className="text-lg font-heading-semibold text-text-primary mb-4">Login History</h3>
        
        <div className="space-y-3">
          {loginHistory.map((login) => (
            <div key={login.id} className="flex items-center justify-between p-3 border border-border rounded-trading">
              <div className="flex items-center space-x-3">
                <div className={`w-2 h-2 rounded-full ${
                  login.status === 'success' ? 'bg-success' : 'bg-error'
                }`} />
                <div>
                  <p className="font-body-medium text-text-primary text-sm">
                    {formatDate(login.timestamp)}
                  </p>
                  <p className="text-sm text-text-secondary">
                    {login.location} • {login.ipAddress} • {login.device}
                  </p>
                </div>
              </div>
              
              <span className={`px-2 py-1 text-xs rounded-trading ${
                login.status === 'success' ?'bg-success-100 text-success' :'bg-error-100 text-error'
              }`}>
                {login.status === 'success' ? 'Success' : 'Failed'}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SecuritySettings;